import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      color: palette.text.white,
      fontWeight: 700,
      display: 'flex',
      gap: '10px'
    },
    contentBlock: {
      display: 'flex'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
